import { NgModule } from '@angular/core';

/* ********************************************************************************* *
 * Angular Material
 * ********************************************************************************* */
import { MatMenuModule } from '@angular/material/menu';

/* ********************************************************************************* *
 * Shared Components
 * ********************************************************************************* */
import { AvatarModule } from '@shared/components/avatar/avatar.module';
import { BrandModule } from '@shared/components/brand/brand.module';

/* ********************************************************************************* *
 * Exported Components
 * ********************************************************************************* */
import { NavbarLayoutComponent } from './navbar-layout.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SigninAsDialogModule } from '@shared/components/dialogs/signin-as-dialog/signin-as-dialog.module';
import { SigninAsDialogComponent } from '@shared/components/dialogs/signin-as-dialog/signin-as-dialog.component';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NpsDialogModule } from '@shared/dialogs/nps-dialog/nps-dialog.module';
import { VerticalAlignerModule } from '@shared/components/vertical-aligner/vertical-aligner.module';
import { IconModule } from '@shared/directives/icon/icon.module';
import { CreateTicketDialogModule } from '@shared/components/dialogs/create-ticket-dialog/create-ticket-dialog.module';

@NgModule({
    declarations: [
        NavbarLayoutComponent
    ],
    imports: [
        CommonModule,
        CreateTicketDialogModule,
        RouterModule,
        AvatarModule,
        BrandModule,
        MatMenuModule,
        SigninAsDialogModule,
        MatSlideToggleModule,
        FormsModule,
        MatTooltipModule,
        NpsDialogModule,
        VerticalAlignerModule,
        IconModule,
        ReactiveFormsModule
    ],
    exports: [
        NavbarLayoutComponent
    ],
    providers: []
})
export class NavbarLayoutModule { }
